<template>
  <div>
    <div class="sm:px-6">
      <slot name="supplier" />
    </div>

    <div class="pt-6">
      <div class="sm:px-6">
        <input-with-icon icon="icon-calendar">
          <input readonly
            type="text"
            class="input rounded w-full h-12"
            placeholder="Select guest"
            :value="dateDisplay"
            @click="handleDateClicked" />
        </input-with-icon>

        <fake-select
          class="mt-4"
          :value="guestDisplay"
          placeholder="Add travelers"
          @click="handleGuestsClicked"
        />

        <ul class="list-reset mt-6">
          <li v-for="(programmes, key, index) in cartItems"
            :key="index"
            class="item-row">
            <span class="text-left">
              {{ programmes.length }}x
            </span>
            <span class="text-left">
              {{ programmes[0].name }}
            </span>
            <span class="text-right">
              <currency-context>
                <template v-slot="{ convert }">
                  <span
                    v-text="convert(getItemPrice(programmes[0]))"
                  ></span>
                </template>
              </currency-context>
            </span>
          </li>

          <li class="border-t separator-slim my-6" />

          <li class="total-row font-medium">
            <span class="text-left">Total:</span>
            <span class="text-right">
              <currency-context>
                <template v-slot="{ convert }">
                  <span
                    v-text="convert(total)"
                  ></span>
                </template>
              </currency-context>
            </span>
          </li>
        </ul>

        <button type="button"
          class="btn btn-primary w-full mt-6"
          :disabled="isSubmitting"
          @click="handleEnquire">
          Enquire
        </button>
      </div>

      <slot name="policies" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import {
  ECOVENTURE_CATEGORIES
} from '../../../helpers/constants'
import {
  getBookingDateDisplay,
  getBookingGuestsDisplay
} from '../../../helpers'

import InputWithIcon from '../../core/InputWithIcon'
import FakeSelect from '../../core/FakeSelect'
import CurrencyContext from "../../core/CurrencyContext";

export default {
  components: {
    InputWithIcon,
    FakeSelect,
    CurrencyContext
  },
  computed: {
    ...mapState(['formData', 'selectedProgrammes', 'isSubmitting']),
    ...mapGetters(['cartItems']),
    dateDisplay () {
      return getBookingDateDisplay(this.formData.date, null)
    },
    guestDisplay () {
      return getBookingGuestsDisplay(this.formData.guests)
    },
    total () {
      return this.selectedProgrammes.reduce((agg, programme) => {
        return agg + this.getItemPrice(programme)
      }, 0)
    }
  },
  methods: {
    handleDateClicked () {
      this.$store.commit('setForceShowDatePicker', true)
    },
    handleGuestsClicked () {
      this.$store.commit('setForceShowGuestsPicker', true)
    },
    getItemPrice (item) {
      if (item.category === ECOVENTURE_CATEGORIES.ECOVENTURE) {
        return item.eco_weekly_price
      }
      else if (item.category === ECOVENTURE_CATEGORIES.EXPEDITION) {
        return item.expedition_price
      }

      return 0
    },
    handleEnquire () {
      this.$store.dispatch('doEnquire')
    }
  }
}
</script>

<style scoped>
li.item-row {
  display: grid;
  grid-template-columns: 30px auto 100px;
}

.total-row {
  display: grid;
  grid-template-columns: auto 100px;
}
</style>